import React from 'react';
import { ListItemButtonProps } from './types';
import { Button } from '@mui/material';

const ListItemButton = ({
  onClick,
  buttonText,
  buttonIcon,
  buttonSecondary,
}: ListItemButtonProps) => {
  return (
    <Button
      variant='outlined'
      className={'list-item-button' + (buttonSecondary ? ' button-secondary' : '')}
      onClick={onClick}
    >
      {buttonIcon ? buttonIcon : null}
      <span className='button-text'>{buttonText}</span>
    </Button>
  );
};

export default ListItemButton;
